import { useState } from 'react';
import { Building2, Mail, MessageSquare, Send, UserRound } from 'lucide-react';
import { submitContact } from '../../services/contactService.js';

const initialForm = {
  name: '',
  email: '',
  company: '',
  role: '',
  message: '',
  website: '',
};

export function ContactForm() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('idle');
  const [feedback, setFeedback] = useState('');

  function updateField(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setStatus('submitting');
    setFeedback('');

    try {
      await submitContact(form);
      setForm(initialForm);
      setStatus('success');
      setFeedback('Gracias. Recibi tus datos y te respondere pronto.');
    } catch (error) {
      setStatus('error');
      setFeedback(error.message);
    }
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-grid">
        <label>
          <span>
            <UserRound size={16} /> Nombre
          </span>
          <input
            autoComplete="name"
            maxLength="120"
            name="name"
            onChange={updateField}
            placeholder="Tu nombre"
            required
            type="text"
            value={form.name}
          />
        </label>

        <label>
          <span>
            <Mail size={16} /> Email
          </span>
          <input
            autoComplete="email"
            maxLength="160"
            name="email"
            onChange={updateField}
            placeholder="tu@email.com"
            required
            type="email"
            value={form.email}
          />
        </label>

        <label>
          <span>
            <Building2 size={16} /> Empresa
          </span>
          <input
            autoComplete="organization"
            maxLength="120"
            name="company"
            onChange={updateField}
            placeholder="Empresa o proyecto"
            type="text"
            value={form.company}
          />
        </label>

        <label>
          <span>
            <UserRound size={16} /> Rol
          </span>
          <input
            autoComplete="organization-title"
            maxLength="120"
            name="role"
            onChange={updateField}
            placeholder="Recruiter, founder, tech lead"
            type="text"
            value={form.role}
          />
        </label>
      </div>

      <label>
        <span>
          <MessageSquare size={16} /> Mensaje
        </span>
        <textarea
          maxLength="1200"
          name="message"
          onChange={updateField}
          placeholder="Cuéntame brevemente la oportunidad, proyecto o motivo de contacto."
          required
          rows="5"
          value={form.message}
        />
      </label>

      <label className="hidden-field" aria-hidden="true">
        Website
        <input
          autoComplete="off"
          name="website"
          onChange={updateField}
          tabIndex="-1"
          type="text"
          value={form.website}
        />
      </label>

      <div className="form-footer">
        <p>
          Guardare estos datos solo para responderte y dar seguimiento profesional a la conversacion.
        </p>
        <button className="button primary" disabled={status === 'submitting'} type="submit">
          {status === 'submitting' ? 'Enviando...' : 'Enviar contacto'}
          <Send size={18} />
        </button>
      </div>

      {feedback ? <p className={`form-feedback ${status}`}>{feedback}</p> : null}
    </form>
  );
}
